import type { ConfirmationGalaxyHotel } from '@/types/galaxy-data/hotel'
import { defineStore } from 'pinia'

export const useConfirmationStore = defineStore('booking-confirmation', {
  state: () => ({
    hotel: undefined as ConfirmationGalaxyHotel | undefined,
    /** ID of the stored cart (we get it from a query param in the URL) */
    cartId: undefined as string | undefined,
  }),
  actions: {
    setHotel(hotelData: ConfirmationGalaxyHotel) {
      this.hotel = hotelData
    },
  },
})
